<template>
    <card class="mb-4">
        <card-header>Invites Overview</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner style="height: 240px;"/>
        </card-body>
        <card-body class="pt-0" v-if="!loading">
            <div class="row">
                <div class="col justify-content-center">
                    <count-metric :title="invites_total.label" :count="invites_total.value" text-position="bottom"/>
                </div>
                <div class="col justify-content-center">
                    <percent-metric :title="invites_scheduled.value + ' Invites ' + invites_scheduled.label" :number="percent(invites_scheduled.value)" color="#455a64" text-position="bottom"/>
                </div>
                <div class="col justify-content-center">
                    <percent-metric :title="invites_opened.value + ' Invites ' + invites_opened.label" :number="percent(invites_opened.value)" color="#81c784" text-position="bottom"/>
                </div>
                <div class="col justify-content-center">
                    <percent-metric :title="invites_shared.value + ' ' + invites_shared.label" :number="percent(invites_shared.value)" color="#2e7d32" text-position="bottom"/>
                </div>
                <div class="col justify-content-center">
                    <percent-metric :title="invites_failed.value + ' Invites ' + invites_failed.label" :number="percent(invites_failed.value)" color="#dc3545" text-position="bottom"/>
                </div>
            </div>
        </card-body>
    </card>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: {
            type: {default: 'public'},
        },

        data: () => ({
            loading: false,
            metrics: [],
            colors : ['#0374d7', '#BBDEFB', '#e6e6e6', '#C8E6C9', '#66BB6A'],
        }),

        created() {
            this.loading = true;
            this.fetchInvitesOverview().then(() => this.loading = false);
        },

        computed: {
            ...mapState(['filter']),
            invites_total() {
                return this.metrics.find(m => m.name === 'Invites');
            },
            invites_scheduled() {
                return this.metrics.find(m => m.name === 'Scheduled');
            },
            invites_failed() {
                return this.metrics.find(m => m.name === 'Failed');
            },
            invites_opened() {
                return this.metrics.find(m => m.name === 'Opened');
            },
            invites_shared() {
                return this.metrics.find(m => m.name === 'Shared');
            },
        },

        watch: {
            filter() {
                this.fetchInvitesOverview().then(() => this.loading = false);
            },
        },

    methods: {
        async fetchInvitesOverview() {
            const params = {
                ...this.filter,
                type: this.type,
                interval: 'yearly'
            };
            const { data: metrics } = await this.$http.get(this.$laroute.route('api.invites.overview'), { params });
            return this.metrics = metrics;
        },
        percent(value) {
            if (!this.invites_total.value) return 0;
            return _.round((value * 100) / this.invites_total.value);
        },
    }
}
</script>
